export const PLATFORMS = Object.freeze({
  hctv: 'hctv',
  tv: 'tv',
  phone: 'phone',
});

export const BANNER_TYPES = Object.freeze({
  categoryBanner: 'categoryBanner',
  subcategoryBanner: 'subcategoryBanner',
});

export const ASPECT_RATIO = Object.freeze({
  HC_BANNER: {
    height: 426,
    width: 1920,
    aspectRatio: '1920:426',
  },
  HC_SUB_BANNER: {
    height: 142,
    width: 499,
    aspectRatio: '499:142',
  },
  FULLSCREEN: {
    height: 1080,
    width: 1920,
    aspectRatio: '16:9',
  },
  SIMPLE_GRID: {
    height: 335,
    width: 571,
    aspectRatio: '571:335',
  }
});
